import _ from 'lodash';
import moment from 'moment';
import humanFormat from 'human-format';

const formatMoney = money => (
  _.toUpper(`$${humanFormat(money, { decimals: 2, separator: '' }).replace(/g/i, 'b')}`)
);

const formatDate = date => moment(date).format('DD/MM/YYYY');

const formatInvestorVehicle = d => {
  const lowerText = _.toLower(d);
  if (lowerText === 'wholesale trust') {
    return 'wholesale';
  }
  return null;
};

export {
  formatMoney,
  formatDate,
  formatInvestorVehicle,
};
